'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgBookmarkFill } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { AuthQueryOptions } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import type { FilterType, SortType } from '../_types/types';
export const StatisticsCard = t0 => {
  const $ = _c(39);
  const {
    sort
  } = t0;
  const router = useCustomRouter();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("filter");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentFilter = t1 as FilterType | null;
  const [hasClickedNew, setHasClickedNew] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasClickedNew(localStorage.getItem("policy-new-clicked") === "true");
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== sort) {
    t4 = AuthQueryOptions["get:/wello/v2/auth/recommend-policy"]({
      query: {
        recommendPolicySort: sort,
        recommendViewType: "TIMELINE"
      }
    });
    $[4] = sort;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      ...t4,
      select: _temp
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data
  } = useQuery(t5);
  const availableCount = data?.availableCount ?? 0;
  const newCount = data?.newCount ?? 0;
  const closingSoonCount = data?.closingSoonCount ?? 0;
  const scrapCount = data?.scrapCount ?? 0;
  let t6;
  if ($[8] !== availableCount) {
    t6 = {
      label: "\uC2E0\uCCAD\uAC00\uB2A5",
      count: availableCount,
      filter: "available" as const
    };
    $[8] = availableCount;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = newCount > 0 && !hasClickedNew;
  let t8;
  if ($[10] !== newCount || $[11] !== t7) {
    t8 = {
      label: "\uC2E0\uADDC",
      count: newCount,
      filter: "new" as const,
      showDot: t7
    };
    $[10] = newCount;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== closingSoonCount) {
    t9 = {
      label: "\uB9C8\uAC10\uC784\uBC15",
      count: closingSoonCount,
      filter: "deadline" as const
    };
    $[13] = closingSoonCount;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== scrapCount) {
    t10 = {
      label: "\uC2A4\uD06C\uB7A9",
      count: scrapCount,
      filter: "scrap" as const,
      showIcon: true
    };
    $[15] = scrapCount;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t8 || $[20] !== t9) {
    t11 = [t6, t8, t9, t10];
    $[17] = t10;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const items = t11;
  let t12;
  let t13;
  if ($[22] !== availableCount || $[23] !== closingSoonCount || $[24] !== currentFilter || $[25] !== newCount || $[26] !== router || $[27] !== scrapCount || $[28] !== searchParams) {
    t12 = () => {
      if (!currentFilter) {
        return;
      }
      const counts = {
        available: availableCount,
        new: newCount,
        deadline: closingSoonCount,
        scrap: scrapCount
      };
      if (counts[currentFilter] === 0) {
        const params = new URLSearchParams(searchParams?.toString());
        params.delete("filter");
        router.replace(ROUTES.RECOMMEND_POLICY_LIST.withSearchParams({
          searchParams: Object.fromEntries(params)
        }));
      }
    };
    t13 = [currentFilter, availableCount, newCount, closingSoonCount, scrapCount, router, searchParams];
    $[22] = availableCount;
    $[23] = closingSoonCount;
    $[24] = currentFilter;
    $[25] = newCount;
    $[26] = router;
    $[27] = scrapCount;
    $[28] = searchParams;
    $[29] = t12;
    $[30] = t13;
  } else {
    t12 = $[29];
    t13 = $[30];
  }
  useEffect(t12, t13);
  let t14;
  if ($[31] !== currentFilter || $[32] !== router || $[33] !== searchParams) {
    t14 = filter => {
      const activeFilter = currentFilter ?? "available";
      if (activeFilter === filter) {
        return;
      }
      if (filter === "new") {
        localStorage.setItem("policy-new-clicked", "true");
        setHasClickedNew(true);
      }
      const params_0 = new URLSearchParams(searchParams?.toString());
      if (filter === "available") {
        params_0.delete("filter");
      } else {
        params_0.set("filter", filter);
      }
      router.push(ROUTES.RECOMMEND_POLICY_LIST.withSearchParams({
        searchParams: Object.fromEntries(params_0)
      }));
    };
    $[31] = currentFilter;
    $[32] = router;
    $[33] = searchParams;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const handleFilterClick = t14;
  let t15;
  if ($[35] !== currentFilter || $[36] !== handleFilterClick || $[37] !== items) {
    t15 = <section className="mx-20 mb-20 flex h-80 items-center gap-12 rounded-medium bg-Gray-white p-8 mobile-sm:h-72 mobile-sm:gap-2">{items.map(item => {
        const isEmpty = item.count === 0;
        const activeFilter_0 = currentFilter ?? "available";
        const isActive = activeFilter_0 === item.filter;
        return <button type="button" key={item.label} onClick={() => handleFilterClick(item.filter)} disabled={isEmpty} className={cn("group flex flex-1 flex-col items-center justify-center gap-0 rounded-medium py-8 transition-colors duration-200", !isEmpty && "hover:bg-Gray-50/40", !isEmpty && "active:bg-Gray-100", isActive && "bg-Gray-50", isEmpty && "cursor-not-allowed opacity-50")} aria-label={isEmpty ? `${item.label} 항목이 없습니다` : `${item.label} 필터 ${isActive ? "\uD574\uC81C" : "\uC801\uC6A9"}`} aria-pressed={isActive} aria-disabled={isEmpty}><span className={cn("relative flex items-center gap-2 font-600 text-Gray-600 transition-colors group-hover:text-Gray-800", "typo-body4 mobile-sm:typo-caption1")} aria-hidden="true">{item.label}{item.showIcon && <SvgBookmarkFill className="size-12" />}{item.showDot && <div className="absolute -right-8 top-0 size-4 animate-pulse rounded-pill bg-O-500" />}</span><span className={cn("font-600 typo-body2 mobile-sm:typo-body4", item.count === 0 ? "text-Gray-400" : "text-Gray-900", isActive && "text-B-500")}>{item.count}건</span></button>;
      })}</section>;
    $[35] = currentFilter;
    $[36] = handleFilterClick;
    $[37] = items;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}